import { render, staticRenderFns } from "./MoleculeContentSliderBrochure.vue?vue&type=template&id=6c51fcbe&"
import script from "./MoleculeContentSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentSliderBrochure.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentSliderBrochure.vue?vue&type=style&index=0&id=6c51fcbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports